import React from 'react';
import { BrannanWebsiteHeaderSettings } from '@apps/guest/websiteHeader';
import { EventPageType } from '@graphql/generated';
import { sendMessageToParentWindow } from '@shared/utils/previewMessageBus';
import { InlineEditor } from '@shared/components';
import { Box } from '@withjoy/joykit';
import { PhotoPresentationLayout } from '@shared/utils/photoPresentationLayout';

const FULL_WIDTH_LAYOUTS: PhotoPresentationLayout[] = ['fullWidth', 'photoSlider', 'photoTrio'];

export interface HeaderPhotoV2Props {
  websiteHeader: NonNullable<BrannanWebsiteHeaderSettings['websiteHeader']>;
  pageSlug?: string;
  pageType: Maybe<EventPageType>;
  children: React.ReactNode;
}

export const HeaderPhoto = (props: HeaderPhotoV2Props) => {
  const { children, websiteHeader, pageSlug, pageType } = props;
  const handleEditPhotoClick = () => {
    // send the message to the parent window to open the photo editor
    sendMessageToParentWindow({
      action: 'inlineEditingInteraction',
      source: 'joyPreview',
      value: { action: 'editHeaderPhoto' }
    });
  };

  if (pageType === EventPageType.welcome) {
    return (
      <Box paddingTop={websiteHeader.headerPhoto.photos?.length ? { _: 0, sm4: 9 } : 0}>
        <InlineEditor
          elementLabel="Photo"
          wrapperType="actionInside"
          actionData={{
            editPhoto: handleEditPhotoClick
          }}
          componentName="headerPhoto"
          pageName={pageType}
          pageSlug={pageSlug || ''}
          wrapperCSS={FULL_WIDTH_LAYOUTS.includes(websiteHeader.headerPhoto?.presentationLayout) ? { width: '100vw', left: 'calc(-50vw + 50%)' } : {}}
        >
          {children}
        </InlineEditor>
      </Box>
    );
  }

  return null;
};
